import { useState } from "react";
import { CarouselLayout, FocusLayout, FocusLayoutContainer, ParticipantTile } from "@livekit/components-react";
import { Loader } from "@shared/ui/loader/loader";
import s from "./focused-layout.module.scss";
import classNames from "classnames";

export const FocusedLayout = ({ tracks, focusTrack, focusClassName, carouselClassName, ...props }) => {
	const [focusedParticipant, setFocusedParticipant] = useState(null);

  const handleParticipantClick = (e) => {
    setFocusedParticipant(e.track.trackSid);
  };

	if(!tracks.length && !focusTrack){
		return <Loader/>
	}

	const focusedTrackRef = focusTrack || tracks.find(
		t => t?.publication?.trackSid === (focusedParticipant || tracks[0]?.publication?.trackSid)
	);

	// Когда демонстрация экрана закреплена в фокусе — в окне с камерой показываем собеседника,
	// а не себя (сортировка тайлов ставит локальную камеру первой, из-за чего собеседник
	// обрезался переполненной каруселью)
	const carouselTracks = focusTrack
		? tracks.filter(t => !t.participant.isLocal)
		: tracks.filter(t => t?.publication?.trackSid !== (focusedParticipant || tracks[0]?.publication?.trackSid));

  return (
		<FocusLayoutContainer className={classNames(s.focusLayout, focusClassName)}>
			<div className={s.focused}>
				<FocusLayout trackRef={focusedTrackRef}/>
			</div>

			{carouselTracks.length > 0 && (
				<CarouselLayout
					className={classNames(s.carousel, carouselClassName)}
					tracks={carouselTracks}>
					<ParticipantTile onParticipantClick={focusTrack ? undefined : handleParticipantClick}/>
				</CarouselLayout>
			)}
		</FocusLayoutContainer>
  );
}
